"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _LoadingIndicator = _interopRequireDefault(require("./LoadingIndicator"));
var _CollapsibleTable = _interopRequireWildcard(require("./CollapsibleTable"));
var _JsonEditor = _interopRequireDefault(require("./JsonEditor"));
var _objects = require("../objects");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "results_drawer-module__container___PtrNW",
  "results_header": "results_drawer-module__results_header___Ss9sT",
  "results_container": "results_drawer-module__results_container___fxOp2",
  "tab": "results_drawer-module__tab___fdbCw",
  "loading_indicator": "results_drawer-module__loading_indicator___kYkEz",
  "collapsible_container": "results_drawer-module__collapsible_container___v0JI7",
  "header_padding": "results_drawer-module__header_padding___CbAOu"
};
class ResultsDrawer extends _react.default.Component {
  static propTypes = {
    isOpen: _propTypes.default.bool,
    onClose: _propTypes.default.func,
    results: _propTypes.default.arrayOf(_propTypes.default.shape(_CollapsibleTable.CollapsibleTableRow)),
    initialWidth: _propTypes.default.number,
    minWidth: _propTypes.default.number,
    maxWidth: _propTypes.default.number,
    contentBefore: _propTypes.default.element,
    loadingDisplayId: _propTypes.default.string,
    drawerTitle: _propTypes.default.string,
    message: _propTypes.default.string,
    messageClassName: _propTypes.default.string,
    className: _propTypes.default.string,
    defaultExpand: _propTypes.default.bool,
    hideFooter: _propTypes.default.bool
  };
  static defaultProps = {
    results: [],
    initialWidth: 742,
    minWidth: 450,
    maxWidth: 1000,
    loadingDisplayId: "au.resultsDrawer.loadingIndicator",
    drawerTitle: undefined,
    className: '',
    message: undefined,
    messageClassName: '',
    defaultExpand: true,
    hideFooter: true
  };
  render() {
    const {
      isOpen,
      onClose,
      results,
      loading,
      initialWidth,
      minWidth,
      maxWidth,
      contentBefore,
      loadingDisplayId,
      drawerTitle,
      message,
      messageClassName,
      className,
      defaultExpand,
      hideFooter
    } = this.props;
    if (!isOpen) {
      return null;
    }
    const drawerMap = (0, _map.default)(results).call(results, result => ({
      ...result,
      children: result.children || /*#__PURE__*/_react.default.createElement(_JsonEditor.default, {
        defaultExpand: defaultExpand,
        content: {
          json: result.data
        },
        readOnly: true
      })
    }));
    return /*#__PURE__*/_react.default.createElement(_objects.Popout, {
      className: (0, _classnames.default)(styles.container, className),
      buttonClassName: "json_button",
      nuevo: true,
      resizable: true,
      onCloseClick: onClose,
      initialWidth: initialWidth,
      minWidth: minWidth,
      maxWidth: maxWidth,
      hideFooter: hideFooter,
      popoutHeader: drawerTitle && /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        className: styles.results_header,
        displayString: drawerTitle,
        tag: "div"
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.results_container
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: "au.resultsDrawer.jsonView",
      className: styles.tab,
      tag: "div"
    }), /*#__PURE__*/_react.default.createElement(_CollapsibleTable.default, {
      contentBefore: contentBefore,
      message: message,
      messageClassName: messageClassName,
      rows: drawerMap,
      containerClassName: (0, _classnames.default)(styles.collapsible_container, {
        [styles.header_padding]: Boolean(drawerTitle)
      })
    }), loading && /*#__PURE__*/_react.default.createElement(_LoadingIndicator.default, {
      className: styles.loading_indicator,
      displayId: loadingDisplayId
    })));
  }
}
exports.default = ResultsDrawer;